import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import Container from "./Container"
import Link from "./Link"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronRight,
} from "@fortawesome/pro-light-svg-icons"

library.add(
  faChevronRight,
)

const StyledRibbon = styled.div`
  ${tw`text-center bg-yellow leading-tight py-1 border-yellow-dark border-b tracking-wide`}
  a {
    ${tw`inline-block transition-all duration-300 ease-in-out py-1 bg-no-repeat`}
    background-image: linear-gradient(to top, currentColor 2px,transparent 2px);
    background-size: 0 100%;
    &:hover {
      background-size: 100% 100%;
    }
  }
  svg {
    vertical-align: -0.0825em;
  }
`

const Ribbon = ({ text, linkTo }) => {
  return (
    <StyledRibbon>
      <Container>
        <p>
          {linkTo ? (
            <Link to={linkTo}>
              {text}
              {` `}
              <FontAwesomeIcon icon={["fal", "chevron-right"]} size="xs" />
            </Link>
          ) : (
            text
          )}
        </p>
      </Container>
    </StyledRibbon>
  )
}

export default Ribbon
